import React from 'react';

export const Welcome = () => {
  return (
    <>
      <h1>Bienvenido!!</h1>
    </>
  );
};
